import {Directive} from '@angular/core';
import {sortByProperty} from '../helpers/helpers';
import { Store } from '@ngxs/store';
import { TransactionsState } from '../states/transactions/transactions.state';
import { SetCurrentPage } from '../states/transactions/transactions.actions';

@Directive({
  selector: '[appBaseTable]',
})
export class BaseTableDirective {
  tableColumns;

  throttle = 0;
  scrollDistance = 2;
  currentPage = 0;
  pageSize = 20;

  /**
   *
   */
  constructor(protected store: Store) {
  }
  
  loadData: () => void;

  sort(array, column: string): any[] {
    if (this.tableColumns) {
      Object.entries(this.tableColumns).map(([k, v]) => {
        if (column !== k) {
          this.tableColumns[k] = true;
        }
      });
    }

    const deepCopyArray = array.map(obj => Object.assign({}, obj));
    this.tableColumns[column] = !this.tableColumns[column];

    return sortByProperty(deepCopyArray, column, this.tableColumns[column]);
  }

  apply_existing_sort(array, column): any[] {
    let sortDir = false;

    if (this.tableColumns) {
      Object.entries(this.tableColumns).map(([k, v]) => {
        if (column !== k) {
          sortDir = this.tableColumns[k];
        }
      });
    }

    const deepCopyArray = array.map(obj => Object.assign({}, obj));

    return sortByProperty(deepCopyArray, column, this.tableColumns[column]);
  }

  onScrollDown() {
    this.currentPage = this.store.selectSnapshot(TransactionsState)?.currentPage;
    this.currentPage++;
    this.store.dispatch(new SetCurrentPage(this.currentPage));
    this.loadData();
  }

  resetPagingValues() {
    this.currentPage = 0;
    this.store.dispatch(new SetCurrentPage(0));
  }

  forceScrollUp(element) {
    element?.scroll({
      top: 0,
      left: 0
    });
  }
}
